<template>
  <div>
    <Head :title="__(title)" />
    <trashed-message v-if="categoryData.deleted_at" class="mb-6" @restore="restore">
      {{ __('This category has been deleted.') }}
    </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input 
            v-model="form.name" 
            :error="form.errors.name" 
            class="pb-8 pr-6 w-full lg:w-1/2"
            :label="__('Name')" 
            required
          />
          <select-input 
            v-model="form.status" 
            :error="form.errors.status" 
            class="pb-8 pr-6 w-full lg:w-1/2"
            :label="__('Status')">
            <option :value="true">{{ __('Active') }}</option>
            <option :value="false">{{ __('Inactive') }}</option>
          </select-input>
          <textarea-input 
            v-model="form.description" 
            :error="form.errors.description" 
            class="pb-8 pr-6 w-full"
            :label="__('Description')" 
          />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button 
            v-if="!categoryData.deleted_at" 
            class="text-red-600 hover:underline" 
            tabindex="-1" 
            type="button" 
            @click="destroy">
            {{ __('Delete Category') }}
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ __('Update Category') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    title: String,
    category: Object,
  },
  remember: 'form',
  data() {
    return {
      categoryData: this.category,
      form: this.$inertia.form({
        name: this.category.name,
        description: this.category.description,
        status: this.category.status,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('student-categories.update', this.categoryData.id))
    },
    destroy() {
      if (confirm(this.__('Are you sure you want to delete this category?'))) {
        this.$inertia.delete(this.route('student-categories.destroy', this.categoryData.id))
      }
    },
    restore() {
      if (confirm(this.__('Are you sure you want to restore this category?'))) {
        this.$inertia.put(this.route('student-categories.restore', this.categoryData.id))
      }
    },
  },
}
</script>
